import React from 'react'
import { SearchBar, SideNav, TabPanel } from '../Screens/index.js'
import { QueryStats } from '@mui/icons-material'
import { useSearch } from '../hooks/useSearch.js'
import AramGodPage from './AramGodPage.js'
import MatchDataPage from './MatchDataPage.js'
import MasteryPointsPage from './MasteryPointsPage.js'
import TftPage from './TftPage.js'

const HomePage = () => {
  const { state, actions } = useSearch()
  const { data, value, message, isLoading, summonerName, region, searchHistory } = state
  const { handleSearch, handleTabChange, setSummonerName, setRegion } = actions

  return (
    <div className="app-container">
      <header className="header">
        <div className="header-bar">
          <div className="header-center">
            <SearchBar
              summonerName={summonerName} region={region} searchHistory={searchHistory} setSummonerName={setSummonerName}
              handleSearch={handleSearch} isLoading={isLoading} setRegion={setRegion}
            />
          </div>
        </div>
        <div className="flow-divider" />
      </header>

      <div className="home-body">
        <SideNav value={value} handleChange={handleTabChange} />
        <main className="home-content">
          <div className={`content-surface${Object.keys(data).length === 0 ? ' content-surface--empty' : ''}`}>
            {Object.keys(data).length === 0
              ? (
              <div className="content-placeholder">
                <div className="content-placeholder__icon">
                  <QueryStats fontSize="large" />
                </div>
              <div className="content-placeholder__title">No data yet</div>
              <div className="content-placeholder__text">
                {message || 'Search a summoner above to load match history, ARAM stats, and mastery insights.'}
              </div>
              <div className="content-placeholder__hint">Example: G2 Celestial#EUNE</div>
            </div>
                )
              : (
              <>
                <TabPanel value={value} index={0}>
                  <TftPage data={data} />
                </TabPanel>
                <TabPanel value={value} index={1}>
                  <MatchDataPage data={data} />
                </TabPanel>
                <TabPanel value={value} index={2}>
                  <AramGodPage data={data} />
                </TabPanel>
                <TabPanel value={value} index={3}>
                  <MasteryPointsPage data={data} />
                </TabPanel>
              </>
                )}
          </div>
        </main>
      </div>
    </div>
  )
}

export default HomePage
